export default __webpack_public_path__ + "static/media/background-check-home.c6c8c23d.svg";